import React from "react";
import Layout from "../layout/Layout";

const PoliticasPrivacidad = () => {
  return (
    <Layout>
      <div class="p-6 px-10">
        <div className="text-center mb-3">
          <h1 className="text-2xl">
            <strong>Política de Privacidad de la APP Bomberos Manta</strong>
          </h1>
        </div>

        <p>
          La presente Política de Privacidad describe cómo el{" "}
          <strong>Benemérito Cuerpo de Bomberos de Manta</strong>
          &nbsp;(en adelante, <strong>“nosotros”</strong> o{" "}
          <strong>“la Institución”</strong>) recopila, utiliza, almacena y
          protege los datos personales de los usuarios de la aplicación móvil
          &nbsp; <strong>“APP Bomberos Manta”</strong> (en adelante,{" "}
          <strong>“la Aplicación”</strong>).
        </p>

        <p>
          Al utilizar la Aplicación, el usuario declara que ha leído y
          comprendido esta Política de Privacidad y que acepta sus términos. En
          caso de no estar de acuerdo, debe abstenerse de usar la Aplicación.
        </p>

        <br />
        <h2 className="text-base">
          <strong>1. Responsable del tratamiento de los datos</strong>
        </h2>
        <p>
          <strong>Entidad:</strong> Benemérito Cuerpo de Bomberos de Manta
          <br />
          <strong>Domicilio:</strong> Manta, Cantón Manta, Provincia de Manabí,
          Ecuador
          <br />
          <strong>Sitio web:</strong>{" "}
          <a
            href="https://www.bomberosmanta.gob.ec"
            target="_blank"
            rel="noreferrer"
            className="underline text-sky-500"
          >
            https://www.bomberosmanta.gob.ec
          </a>
          <br />
          <strong>Correo de contacto:</strong>{" "}
          <a href="mailto:tic@bomberosmanta.gob.ec">tic@bomberosmanta.gob.ec</a>
          <br />
          <strong>Área responsable:</strong> Departamento de Tecnologías de la
          Información y Comunicación (TIC)
        </p>

   
        <hr className="my-4"/>
        <strong>
          <h2>2. Usuarios de la aplicación</h2>
        </strong>
        <p>
          La Aplicación está destinada principalmente a personal autorizado del
          Benemérito Cuerpo de Bomberos de Manta y, en su caso, a otros usuarios
          que la Institución determine, quienes reciben un usuario y contraseña
          de acceso. Dichos usuarios firman un acta de entrega y aceptación de
          condiciones de uso de la APP, independiente de esta Política de
          Privacidad.
        </p>

        <hr className="my-4"/>
        <strong>
          <h2>3. Datos personales que se recopilan</h2>
        </strong>
        <p>
          Dependiendo del tipo de usuario y de la configuración institucional,
          la Aplicación puede recopilar y tratar las siguientes categorías de
          datos personales:
        </p>

        <h3 className="mt-2">
          <i className="font-semibold">3.1. Datos de identificación</i>
        </h3>
        <ul>
          <li>
            <span className="font-medium">Datos básicos:</span> nombres y
            apellidos, número de identificación, código interno de bombero o
            usuario.
          </li>
          <li>
            <span className="font-medium">Credenciales de acceso:</span> nombre
            de usuario, contraseña (almacenada de forma cifrada en los sistemas
            institucionales).
          </li>
        </ul>

        <h3 className="mt-2">
          <i className="font-semibold">3.2. Datos de contacto</i>
        </h3>
        <ul>
          <li>Correo electrónico institucional o personal autorizado.</li>
          <li>
            Número de teléfono de contacto (cuando sea requerido para fines
            operativos o de emergencia).
          </li>
        </ul>

        <h3 className="mt-2">
          <i className="font-semibold">3.3. Datos de uso de la aplicación</i>
        </h3>
        <ul>
          <li>
            <i>Registros de actividad en la APP:</i> inicio de sesión, cierre de
            sesión, acciones realizadas, eventos consultados.
          </li>
          <li>
            <i>Datos técnicos:</i> versión de la aplicación, tipo de
            dispositivo, sistema operativo, fecha y hora de acceso.
          </li>
        </ul>

        <h3 className="mt-2">
          <i className="font-semibold">
            3.4. Datos de geolocalización (si aplica)
          </i>
        </h3>
        <p>
          En caso de que la Aplicación incorpore funciones de ubicación, se
          podrá recopilar información de geolocalización aproximada o precisa
          del dispositivo, únicamente para fines operativos de atención de
          emergencias, despacho de recursos y registro de eventos.
        </p>

        <p class="small">
          La activación de la geolocalización depende de la configuración del
          dispositivo y de los permisos otorgados por el usuario en el sistema
          operativo.
        </p>

        <hr className="my-4"/>
        <strong>
          <h2>4. Finalidades del tratamiento de los datos</h2>
        </strong>
        <p>
          Los datos personales recopilados a través de la Aplicación serán
          tratados exclusivamente para las siguientes finalidades:
        </p>
        <ul>
          <li>
            <i className="font-medium">Gestión operativa de emergencias:</i>{" "}
            recepción, consulta y seguimiento de eventos o emergencias dentro
            del cantón Manta y zonas de cobertura.
          </li>
          <li>
            <i className="font-medium">Identificación y autenticación:</i>{" "}
            permitir que los usuarios autorizados ingresen a la Aplicación
            mediante sus credenciales.
          </li>
          <li>
            <i className="font-medium">Registro de actividad institucional:</i>{" "}
            documentar las acciones realizadas por los usuarios en el marco de
            sus funciones.
          </li>
          <li>
            <i className="font-medium">Mejora del servicio:</i> análisis
            estadístico y técnico (no orientado a la vigilancia de personas)
            para mejorar el funcionamiento de la Aplicación.
          </li>
          <li>
            <i className="font-medium">Seguridad y auditoría:</i> prevención de
            accesos no autorizados, detección de usos indebidos y cumplimiento
            de obligaciones legales o administrativas.
          </li>
        </ul>

        <hr className="my-4"/>
        <strong>
          <h2>5. Base legal del tratamiento</h2>
        </strong>
        <p>
          El tratamiento de los datos personales se realiza principalmente sobre
          la base de:
        </p>
        <ul>
          <li>
            <span className="font-medium">
              Cumplimiento de funciones institucionales y de interés público
            </span>{" "}
            del Benemérito Cuerpo de Bomberos de Manta, relacionadas con la
            atención de emergencias y la protección de la ciudadanía.
          </li>
          <li>
            <span className="font-medium">
              Relación laboral, contractual o de servicio
            </span>{" "}
            entre la Institución y el usuario autorizado.
          </li>
          <li>
            <span className="font-medium">Consentimiento informado</span>{" "}
            otorgado por el usuario al aceptar el uso de la Aplicación y firmar
            el acta de entrega de usuario, cuando corresponda.
          </li>
        </ul>

        <hr className="my-4"/>
        <strong>
          <h2>6. Compartición y destinatarios de los datos</h2>
        </strong>
        <p>
          En general, los datos personales tratados a través de la Aplicación se
          utilizan de forma interna por el Benemérito Cuerpo de Bomberos de Manta. Sin
          embargo, se podrá compartir información en los siguientes casos:
        </p>
        <ul>
          <li>
            <strong>Autoridades competentes:</strong> cuando sea requerido por
            ley, por orden judicial o por disposiciones de autoridades de
            control.
          </li>
          <li>
            <strong>Entidades públicas de coordinación de emergencias:</strong>{" "}
            cuando sea necesario para la atención de incidentes y en el marco de
            convenios o protocolos de actuación.
          </li>
          <li>
            <strong>Proveedores tecnológicos:</strong> empresas que prestan
            servicios de infraestructura tecnológica, alojamiento, soporte o
            mantenimiento de la Aplicación, bajo acuerdos de confidencialidad y
            protección de datos.
          </li>
        </ul>
        <p>
          En ningún caso se venderán los datos personales a terceros ni se
          utilizarán para fines comerciales o de publicidad ajenos a la misión
          institucional.
        </p>

        <hr className="my-4"/>
        <strong>
          <h2>7. Conservación de los datos</h2>
        </strong>
        <p>
          Los datos personales se conservarán durante el tiempo necesario para:
        </p>
        <ul>
          <li>
            <strong>Cumplir las finalidades descritas</strong> en esta Política
            de Privacidad.
          </li>
          <li>
            <strong>
              Atender obligaciones legales, regulatorias o administrativas
            </strong>{" "}
            aplicables al Benemérito Cuerpo de Bomberos de Manta.
          </li>
          <li>
            <strong>
              Atender auditorías, investigaciones o requerimientos de
              autoridades
            </strong>
            , dentro de los plazos de prescripción correspondientes.
          </li>
        </ul>
        <p>
          Una vez cumplidas las finalidades o vencidos los plazos legales, se
          procurará la eliminación, anonimización o bloqueo seguro de los datos,
          según corresponda.
        </p>

        <hr className="my-4"/>
        <strong>
          <h2>8. Seguridad de la información</h2>
        </strong>
        <p>
          El Benemérito Cuerpo de Bomberos de Manta, a través del Departamento de TIC,
          implementa medidas técnicas y organizativas razonables para proteger
          los datos personales contra pérdida, uso indebido, acceso no
          autorizado, divulgación, alteración o destrucción.
        </p>
        <p>
          Entre otras medidas, se aplican controles de acceso mediante
          credenciales individuales, uso de contraseñas cifradas, registros de
          actividad y limitación de permisos según el rol de cada usuario. No
          obstante, ningún sistema es completamente seguro y el usuario también
          tiene responsabilidad en la custodia de su usuario y contraseña, tal
          como se establece en el acta de entrega de usuario.
        </p>

        <hr className="my-4"/>
        <strong>
            <h2>9. Derechos de los usuarios sobre sus datos</h2>
        </strong>
        <p>
          De acuerdo con la normativa aplicable en materia de protección de
          datos personales y principios generales de habeas data, los usuarios
          podrán ejercer, según corresponda, los siguientes derechos:
        </p>
        <ul>
          <li>
            <span className="font-medium italic">Acceso:</span> conocer qué datos personales se tratan
            sobre su persona.
          </li>
          <li>
            <span className="font-medium italic">Actualización y rectificación:</span> solicitar la
            corrección de datos inexactos, incompletos o desactualizados.
          </li>
          <li>
            <span className="font-medium italic">Oposición o limitación:</span> oponerse o solicitar la
            limitación del tratamiento cuando existan motivos legítimos, en la
            medida en que no se afecten obligaciones legales o funciones
            institucionales.
          </li>
          <li>
            <span className="font-medium italic">Supresión:</span> solicitar la eliminación de sus datos
            cuando sea procedente y no exista una obligación legal o
            institucional que requiera su conservación.
          </li>
        </ul>
        <p>
          Para ejercer estos derechos, el usuario podrá comunicarse a través de
          los canales indicados en la sección de contacto de esta Política.
        </p>

        <hr className="my-4"/>
        <strong>
            <h2>10. Uso de la aplicación por parte de terceros</h2>
        </strong>
        <p>
          El usuario es responsable de mantener la confidencialidad de sus
          credenciales de acceso y de no compartirlas con terceros. Cualquier
          uso indebido derivado de la divulgación de su usuario y contraseña
          será de su responsabilidad, conforme a lo establecido en el acta de
          entrega de usuario y en los reglamentos internos.
        </p>
        <p>
          En caso de sospecha de acceso no autorizado, pérdida o filtración de
          credenciales, el usuario deberá informar de inmediato al Departamento
          de TIC para tomar las acciones correspondientes (bloqueo, cambio de
          contraseña, etc.).
        </p>

        <hr className="my-4"/>
        <strong>
            <h2>11. Menores de edad</h2>
        </strong>
        <p>
          La Aplicación no está dirigida a menores de edad ni a uso ciudadano
          general. Está destinada a personal institucional y usuarios
          autorizados. No se recaban de forma intencional datos personales de
          menores a través de la APP Bomberos Manta.
        </p>

        <hr className="my-4"/>
        <strong>
            <h2>12. Enlaces a otros servicios o sitios web</h2>
        </strong>
        <p>
          La Aplicación puede contener enlaces a otros sistemas, portales
          institucionales o servicios externos. Esta Política de Privacidad se
          aplica únicamente a la APP Bomberos Manta. El usuario debe revisar las
          políticas de privacidad de los sitios o servicios externos que visite.
        </p>

        <hr className="my-4"/>
        <strong>
            <h2>13. Modificaciones de esta política de privacidad</h2>
        </strong>
        <p>
          El Benemérito Cuerpo de Bomberos de Manta podrá actualizar esta Política de
          Privacidad cuando sea necesario para reflejar cambios en la
          Aplicación, en los procesos de tratamiento de datos o en la normativa
          vigente.
        </p>
        <p>
          Cuando se realicen cambios relevantes, se procurará notificar a los
          usuarios a través de los canales habituales (por ejemplo, avisos en la
          Aplicación o en el sitio web institucional), indicando la fecha de la
          última actualización.
        </p>

        <hr className="my-4"/>
        <strong>
            <h2>14. Contacto</h2>
        </strong>
        <p>
            Para cualquier consulta, solicitud de ejercicio de derechos o duda relacionada con esta Política de Privacidad
            o con el tratamiento de datos personales en la APP Bomberos Manta, el usuario puede contactar a:
        </p>
        <p>
            <strong>Benemérito Cuerpo de Bomberos de Manta</strong><br/>
            Departamento de Tecnologías de la Información y Comunicación (TIC)<br/>
            Sitio web: <a href="https://www.bomberosmanta.gob.ec" target="_blank" rel="noreferrer" className="underline text-sky-500">https://www.bomberosmanta.gob.ec</a><br/>
            Correo electrónico: <a href="mailto:tic@bomberosmanta.gob.ec">tic@bomberosmanta.gob.ec</a>
        </p>

        <p class="text-sm mt-4">
           <strong>Nota:</strong> Esta política se ha redactado para cumplir con los requisitos de transparencia y privacidad exigidos por
            las plataformas de distribución de aplicaciones móviles, incluyendo Google Play.
        </p>

        <br />
        <br />
      </div>
    </Layout>
  );
};

export default PoliticasPrivacidad;
